/**
 * Global sound effects manager
 * Allows playSoundEffect to access context values without requiring hooks
 */

import { isExploreUnknownKendrexColonyAudioSuppressed } from '../utils/exploreUnknownKendrexColonyAudio';

let soundsEnabled = true;
let soundsVolume = 0.5;
let speechVolume = 0.5;
let masterVolume = 1;

/** Unit deploy voice lines: public/sounds/id{N}.mp3 */
const UNIT_SPEECH_PATH_PATTERN = /\/sounds\/id\d+\.mp3$/i;

export function isUnitSpeechPath(soundPath) {
  if (!soundPath || typeof soundPath !== 'string') {
    return false;
  }
  return UNIT_SPEECH_PATH_PATTERN.test(soundPath);
}

export function setSoundSettings(enabled, volume, master = undefined, speech = undefined) {
  soundsEnabled = enabled;
  soundsVolume = volume;
  if (typeof master === 'number' && Number.isFinite(master)) {
    masterVolume = Math.min(1, Math.max(0, master));
  }
  if (typeof speech === 'number' && Number.isFinite(speech)) {
    speechVolume = Math.min(1, Math.max(0, speech));
  }
}

export function getSoundSettings() {
  return { soundsEnabled, soundsVolume, speechVolume, masterVolume };
}

/**
 * Master SFX/voice output: user slider × per-clip gain, clamped to [0, 1].
 * Unit speech (/sounds/id{N}.mp3) uses the speech volume slider; other SFX use sounds volume.
 * Callers should not play audio when this returns null (sounds disabled).
 *
 * @param {number} [relativeClipGain=1] - Per-effect multiplier (e.g. 0.5 for quieter deploy SFX vs full voice line).
 * @returns {null | number}
 */
export function getEffectiveSoundOutputVolume(relativeClipGain = 1, soundPath = null) {
  if (!soundsEnabled) return null;
  if (isExploreUnknownKendrexColonyAudioSuppressed(soundPath)) return null;
  const g =
    typeof relativeClipGain === 'number' && Number.isFinite(relativeClipGain)
      ? Math.max(0, relativeClipGain)
      : 1;
  const categoryVolume = isUnitSpeechPath(soundPath) ? speechVolume : soundsVolume;
  return Math.min(1, masterVolume * categoryVolume * g);
}
